import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NativeAd = ({ placement = "bottom_page", className = "" }) => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNativeAds();
  }, [placement]);

  const fetchNativeAds = async () => {
    try {
      const response = await axios.get(`${API}/native-ads/${placement}`);
      setAds(response.data);
    } catch (error) {
      console.error('Failed to fetch native ads:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdClick = async (ad) => {
    try {
      await axios.post(`${API}/native-ads/${ad.id}/click`);
      if (ad.click_url) {
        window.open(ad.click_url, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      console.error('Failed to track native ad click:', error);
    }
  };

  if (loading) {
    return (
      <div className={`native-ad ${className}`}>
        <div className="animate-pulse">
          <div className="h-6 bg-gray-700 rounded mb-3"></div>
          <div className="h-4 bg-gray-700 rounded mb-2"></div>
          <div className="h-4 bg-gray-700 rounded w-2/3"></div>
        </div>
      </div>
    );
  }

  if (ads.length === 0) {
    return null; // Don't show anything if no ads
  }

  const ad = ads[0]; // Show the first (highest priority) ad

  return (
    <div 
      className={`native-ad cursor-pointer ${className}`}
      onClick={() => handleAdClick(ad)}
      data-testid={`native-ad-${placement}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-3">
            <span className="text-xs bg-orange-600/20 text-orange-400 px-2 py-1 rounded">
              Sponsored
            </span>
          </div>
          
          <h3 className="text-lg font-semibold text-white mb-2 hover:text-orange-400 transition-colors">
            {ad.title}
          </h3>
          
          <p className="text-gray-300 text-sm leading-relaxed mb-4">
            {ad.description}
          </p>
          
          <div className="flex items-center space-x-2 text-orange-400 hover:text-orange-300 transition-colors">
            <span className="text-sm font-medium">Learn More</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </div>
        </div>
        
        {ad.image_url && (
          <div className="ml-6 flex-shrink-0">
            <img 
              src={ad.image_url} 
              alt={ad.title}
              className="w-24 h-24 object-cover rounded-lg border border-orange-500/20"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NativeAd;